import type { Ereignis } from "../gemeinsam/index.js";
import {
  jagdruheAnwenden, jagdzustandAus, JAGDRUHE_EREIGNIS, KEINE_JAGDRUHE, passtZuKontingent, type FreigabeZustand,
} from "../drueckjagd/oeffentlich.js";

/**
 * Regeln der Policies P-16 und P-20 (Domänenmodell §12) als reine Funktionen: Ob ein Schuss bei ruhender Jagd fiel
 * und ob seine Ansprache ein möglicher Fehlabschuss ist. Die Meldung wird in keinem Fall abgewiesen (ADR-0018).
 */

/**
 * Möglicher Fehlabschuss (P-20, F-129, Entscheidung H9): Wildart für diese Drückjagd ausgeblendet, keine oder eine
 * gesperrte Freigabeposition, Ansprache in keinem Kontingent ihrer Wildart (z. B. Hirsch bei „nur Kahlwild“) oder
 * nur in gesperrten Kontingenten. Ohne festgelegte Freigabe gibt es nichts, wogegen die Ansprache geprüft würde; dann
 * gilt nur die ausgeblendete Wildart.
 */
export function moeglicherFehlabschuss(wildart: string, altersklasse: string | null, wildartenDerDrueckjagd: readonly string[],
  freigabe: FreigabeZustand): boolean {
  if (!wildartenDerDrueckjagd.includes(wildart)) return true;
  if (!freigabe.festgelegt) return false;
  const position = freigabe.positionen.find((p) => p.wildart === wildart);
  if (!position || position.gesperrt) return true;
  const kontingente = Object.values(freigabe.kontingente).filter((k) => k.wildart === wildart);
  if (kontingente.length === 0) return false;
  const passende = kontingente.filter((k) => passtZuKontingent(k, wildart, altersklasse));
  return passende.length === 0 || passende.every((k) => k.gesperrt !== null);
}

const EINGRIFFE: readonly string[] = [JAGDRUHE_EREIGNIS.HahnInRuhAusgerufen, JAGDRUHE_EREIGNIS.JagdFreigegeben, JAGDRUHE_EREIGNIS.ZumZeitplanZurueckgekehrt];

/**
 * Ruhte die Jagd zum Zeitpunkt des Schusses (P-16, F-128)? Maßgeblich ist der Zeitpunkt des Geschehens, nicht die
 * Ankunft (`schuss/12`): Eingriffe, die erst danach geschahen, zählen nicht; der Jagdzeitplan gilt in seiner letzten
 * Fassung.
 */
export function schussBeiRuhenderJagd(jagdruhe: readonly Ereignis[], zeitpunkt: Date): boolean {
  const bisDahin = jagdruhe.filter((e) => !EINGRIFFE.includes(e.typ) || new Date(e.daten["Zeitpunkt"] as string | Date).getTime() <= zeitpunkt.getTime());
  return jagdzustandAus(bisDahin.reduce(jagdruheAnwenden, KEINE_JAGDRUHE), zeitpunkt) === "Jagd ruht";
}
